export default __webpack_public_path__ + "static/media/mobile-UNIintro.e9b48045.mov";